function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageScissorsRight = function SvgImageScissorsRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-9.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#FFF",
    d: "M16.082 24.484a2 2 0 0 0-.616.1c-1.293.425-1.897 2.117-1.358 3.767.547 1.65 2.037 2.643 3.329 2.218.525-.166.949-.553 1.234-1.107.387-.762.429-1.731.125-2.658-.457-1.392-1.593-2.322-2.714-2.32zM3.897 0l6.265 12.85 1.676 3.333c1.57 3.492.892 3.725 2.593 5.118 1.08.889 2.656 1.735 3.444 2.349.972.54 1.782 1.504 2.188 2.745.419 1.255.338 2.592-.202 3.672-.438.86-1.154 1.495-2.006 1.773-1.99.658-4.083-.78-5.01-3.072-.592-1.47-.233-5.498-.612-6.927l-3.4-5.763C8.322 14.841 5.61 9.301 4.5 5.308 3.238.766 3.495.045 3.897 0Z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(5.835)"
  })));
};
export { SvgImageScissorsRight as ReactComponent };
export default __webpack_public_path__ + "assets/ImageScissors Right.163bb6f10a164b83ee5d879519aa416e.svg";